import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    nickname: 'Nickname',
    enterNickname: 'Enter your nickname',
    nicknameRequired: 'Nickname is required',
    nicknameTaken: 'This nickname is already taken',
    nicknameRules: 'Nickname must be 2-50 characters',
    join: 'Join Chat',
    joining: 'Joining...',
    leave: 'Leave',
    send: 'Send',
    sending: 'Sending...',
    typeMessage: 'Type a message...',
    messageEmpty: 'Message cannot be empty',
    messageTooLong: 'Message is too long',
    tooFast: 'Please wait before sending another message',
    messageDeleted: 'Message deleted',
    delete: 'Delete',
    onlineUsers: 'Online Users',
    usersCount: 'users online',
    english: 'English',
    traditionalChinese: '繁體中文',
    enterChatroom: 'Enter Chatroom',
    connectingToChat: 'Connecting to chat...',
    noMessages: 'No messages yet. Start the conversation!',
    addEmoji: 'Add Emoji',
    sendError: 'Failed to send message',
  },
  zh: {
    nickname: '暱稱',
    enterNickname: '請輸入暱稱',
    nicknameRequired: '請輸入暱稱',
    nicknameTaken: '此暱稱已被使用',
    nicknameRules: '暱稱必須為2-50個字元',
    join: '加入聊天室',
    joining: '加入中...',
    leave: '離開',
    send: '發送',
    sending: '發送中...',
    typeMessage: '輸入訊息...',
    messageEmpty: '訊息不能為空',
    messageTooLong: '訊息過長',
    tooFast: '請稍候再發送訊息',
    messageDeleted: '訊息已刪除',
    delete: '刪除',
    onlineUsers: '線上用戶',
    usersCount: '位用戶線上',
    english: 'English',
    traditionalChinese: '繁體中文',
    enterChatroom: '進入聊天室',
    connectingToChat: '連接聊天室中...',
    noMessages: '還沒有訊息。開始對話吧！',
    addEmoji: '添加表情',
    sendError: '發送訊息失敗',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(
    localStorage.getItem('preferred-language') || 'en'
  );

  const value = {
    language,
    setLanguage: (lang) => {
      localStorage.setItem('preferred-language', lang);
      setLanguage(lang);
    },
    t: (key) => translations[language][key] || key,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};